import { render, staticRenderFns } from "./DatabaseModal.vue?vue&type=template&id=2f059f86&"
import script from "./DatabaseModal.vue?vue&type=script&lang=js&"
export * from "./DatabaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports